// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextInput_wrapper__3hT7z","input":"TextInput_input__d1W1n","prefix":"TextInput_prefix__1k34D"};